import React from 'react';
import { useSelector } from 'react-redux';
import { ReduxHelpers } from "../../Helpers/ReduxHelpers";
import { saveFileWithDialog, FileTypes } from "../../Utils/FileSaveDialog";

interface RootState {
    refreshLoadedFile: { isLoading: boolean };
    pickAFile: { 
        fileLength: number | null; 
        fileName: string;
        currentDataContents: string;
    };
}

const SaveAsJSONFile: React.FC = () => {
    const isLoading = useSelector((state: RootState) => state.refreshLoadedFile.isLoading);
    const currentFileLength = useSelector((state: RootState) => state.pickAFile.fileLength);
    const currentFileName = useSelector((state: RootState) => state.pickAFile.fileName);
    const currentDataContents = useSelector((state: RootState) => state.pickAFile.currentDataContents);

    const { CreateContentsFromStates } = ReduxHelpers();

    async function SaveFileData() {
        CreateContentsFromStates(JSON.parse(currentDataContents));

        // Use native save dialog with suggested filename
        const jsonFileName = currentFileName.endsWith('.json') ? currentFileName : `${currentFileName}.json`;
        await saveFileWithDialog(currentDataContents, {
            suggestedName: jsonFileName,
            types: FileTypes.JSON
        });
    }

    return (
        <button disabled={currentFileLength == null || isLoading} onClick={SaveFileData} title="Save As JSON">
            Save As JSON
        </button>
    );
};

export default SaveAsJSONFile;